import { Inject, Injectable, PLATFORM_ID } from '@angular/core';
import { getMessaging, getToken, onMessage } from 'firebase/messaging';
import { initializeApp } from 'firebase/app';
import { isPlatformBrowser } from '@angular/common';
import { ToastrService } from 'ngx-toastr';

@Injectable({ providedIn: 'root' })
export class FirebaseService {
  private app: any;
  private messaging: any;

  constructor(
    @Inject(PLATFORM_ID) private platformId: object,
    private toastr: ToastrService,
  ) {}

  private initFirebase() {
    if (!isPlatformBrowser(this.platformId)) return;
    if (this.app) return;
    const firebaseConfig = {
      apiKey: 'AIzaSyBrISRQjvK32hHO7IB0AHU-D5vKg-V-C7Q',
      authDomain: 'highrollers-3e962.firebaseapp.com',
      projectId: 'highrollers-3e962',
      storageBucket: 'highrollers-3e962.firebasestorage.app',
      messagingSenderId: '872545066806',
      appId: '1:872545066806:web:d102ec9a1e476d34d9dd97',
      measurementId: 'G-5HYZPB158H',
    };
    this.app = initializeApp(firebaseConfig);
    this.messaging = getMessaging(this.app);
  }
  async init(): Promise<string | null> {
    if (!isPlatformBrowser(this.platformId)) {
      // this.toastr.error('Firebase is not supported on this platform');
      return null;
    }

    this.initFirebase();

    if (!this.messaging) {
      // this.toastr.error('Firebase messaging is not supported on this platform');
      return null;
    }

    const isEdge = /Edg/i.test(navigator.userAgent);
    if (isEdge) {
      return null;
    }
    const permission = await Notification.requestPermission();
    if (permission !== 'granted') {
      // this.toastr.error('Notification permission is not granted');
      return null;
    }

    const token = await getToken(this.messaging, {
      vapidKey:
        'BNf9mxGWGOLlodFRYsRkzUSqdQc2W1Hcbr4KF-AS6u6-_rPYYKoxeDGkpdG0exU5a1V1-daU4wucdfeZKsXlNtQ',
    });
    if (!token) {
      // this.toastr.error('Failed to get Firebase token');
      return null;
    }
    return token ?? null;
  }

  private listenerInitialized = false;

  listen() {
    if (this.listenerInitialized) return;

    this.listenerInitialized = true;
    if (!isPlatformBrowser(this.platformId)) return;

    this.initFirebase();
    if (!this.messaging) return;

    onMessage(this.messaging, (payload) => {
      console.log('📩 Foreground message received:', payload);

      // if ('Notification' in window) {
      //   new Notification(payload.notification?.title ?? 'New Message', {
      //     body: payload.notification?.body,
      //   });
      // }
    });
  }
}
